import React from 'react'

export const FirewallContext = React.createContext({})

export default function FirewallState({children}) {
    return <FirewallContext.Provider value={{}}>
        {children}
    </FirewallContext.Provider>
}
